import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Contact from "../views/Contact.vue";
import Licensing from "../views/Licensing.vue";
import Privacy from "../views/Privacy.vue";
import ProjectMain from '@/components/ProjectMain.vue'


const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/about",
    name: "About",
    component: About
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact
  },
  {
    path: "/licensing",
    name: "Licensing",
    component: Licensing
  },
  {
    path: "/privacy-policy",
    name: "Privacy",
    component: Privacy
  },
  {
    path: '/testnet',
    name: 'Testnet',
    component: ProjectMain
  },
  {
    path: '/mainnet',
    name: 'Mainnet',
    component: ProjectMain
  },
  {
    path: '/:network/:projectName',
    name: 'ProjectMain',
    component: ProjectMain
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;